import ResponsesRepository from '../../../networking/repos/ResponsesRepository';
import {usePaginationQueryConfig, useQueryConfig} from '../Utils';
import {ResponseQueryKey} from './Key';
import {ResponseIndexRequest} from '../../../networking/requests/Response';

export const useResponseIndexQueryConfig = (universityId: number) => {
    const repo = new ResponsesRepository(universityId);

    return usePaginationQueryConfig(
        (page) => ResponseQueryKey.index({ universityId, page }),
        (page) => repo.allPaginated({ page })
    );
};

export const useResponseWithoutPaginationQueryConfig = (universityId: number, request?: ResponseIndexRequest) => {
    const repo = new ResponsesRepository(universityId);

    return useQueryConfig(ResponseQueryKey.withoutPagination({ universityId, ...request }), () => repo.all(request));
};

export const useResponseDetailQueryConfig = (universityId: number, responseId: number) => {
    const repo = new ResponsesRepository(universityId);

    return useQueryConfig(
        ResponseQueryKey.detail({ universityId, responseId }), () => repo.find(responseId)
    );
};
